module.exports = __webpack_public_path__ + "static/media/skin_laboratory_icon@2x.1cdeb723.png";